import React from "react";
import { Helmet } from "react-helmet-async";
import brand from "../spec/brand";

const Meta = ({ title, description }) => {
  const t = title ? `${title} · ${brand.name}` : `${brand.name} · ${brand.tagline}`;
  const d = description || brand.oneLiner;
  return (
    <Helmet>
      <title>{t}</title>
      <meta name="description" content={d} />
      <meta property="og:title" content={t} />
      <meta property="og:description" content={d} />
      <meta property="og:type" content="website" />
      <meta name="theme-color" content="#FAFAF6" />
    </Helmet>
  );
};

export default Meta;
